/**
 * This file contains the color definitions used in the Lumon rebrand theme.
 * Colors are defined using RGB values with alpha-value placeholder for Tailwind CSS.
 */

module.exports = {
  blue: {
    50: 'rgb(243 248 254 / <alpha-value>)',
    100: 'rgb(208 231 253 / <alpha-value>)',
    200: 'rgb(115 184 250 / <alpha-value>)',
    300: 'rgb(21 136 247 / <alpha-value>)',
    400: 'rgb(11 102 188 / <alpha-value>)',
    500: 'rgb(11 68 124 / <alpha-value>)'
  },
  gray: {
    0: 'rgb(255 255 255 / <alpha-value>)',
    50: 'rgb(247 247 247 / <alpha-value>)',
    100: 'rgb(241 241 241 / <alpha-value>)',
    200: 'rgb(224 224 224 / <alpha-value>)',
    300: 'rgb(201 201 201 / <alpha-value>)',
    400: 'rgb(162 162 162 / <alpha-value>)',
    500: 'rgb(117 117 117 / <alpha-value>)',
    600: 'rgb(69 69 69 / <alpha-value>)',
    700: 'rgb(43 43 43 / <alpha-value>)',
    800: 'rgb(22 22 22 / <alpha-value>)',
    900: 'rgb(0 0 0 / <alpha-value>)'
  },
  green: {
    50: 'rgb(242 248 245 / <alpha-value>)',
    100: 'rgb(204 246 232 / <alpha-value>)',
    200: 'rgb(108 237 193 / <alpha-value>)',
    300: 'rgb(0 204 140 / <alpha-value>)',
    350: 'rgb(0 137 82 / <alpha-value>)',
    400: 'rgb(9 120 76 / <alpha-value>)',
    500: 'rgb(0 104 71 / <alpha-value>)'
  },
  orange: {
    50: 'rgb(255 250 246 / <alpha-value>)',
    100: 'rgb(255 237 214 / <alpha-value>)',
    200: 'rgb(254 190 113 / <alpha-value>)',
    300: 'rgb(254 162 50 / <alpha-value>)',
    350: 'rgb(215 128 24 / <alpha-value>)',
    400: 'rgb(176 107 33 / <alpha-value>)',
    500: 'rgb(127 81 25 / <alpha-value>)'
  },
  purple: {
    50: 'rgb(250 246 250 / <alpha-value>)',
    100: 'rgb(236 227 254 / <alpha-value>)',
    200: 'rgb(213 195 253 / <alpha-value>)',
    300: 'rgb(191 163 251 / <alpha-value>)',
    400: 'rgb(158 117 248 / <alpha-value>)',
    500: 'rgb(79 59 124 / <alpha-value>)'
  },
  red: {
    50: 'rgb(253 244 243 / <alpha-value>)',
    100: 'rgb(253 223 212 / <alpha-value>)',
    200: 'rgb(255 180 171 / <alpha-value>)',
    300: 'rgb(254 137 125 / <alpha-value>)',
    350: 'rgb(209 33 20 / <alpha-value>)',
    400: 'rgb(166 40 22 / <alpha-value>)',
    500: 'rgb(122 49 21 / <alpha-value>)'
  },
  yellow: {
    50: 'rgb(255 252 235 / <alpha-value>)',
    100: 'rgb(255 246 194 / <alpha-value>)',
    200: 'rgb(255 237 128 / <alpha-value>)',
    300: 'rgb(255 227 55 / <alpha-value>)',
    400: 'rgb(252 199 25 / <alpha-value>)',
    500: 'rgb(172 124 5 / <alpha-value>)'
  }
};
